import React, { useEffect } from "react";
import "./App.css";
import "devextreme/dist/css/dx.common.css";
import "./assets/css/dx.material.blue.light.css";
import { locale } from "devextreme/localization";
import { BrowserRouter as Router } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { useAuth } from "./context/authContext";
import Content from "./Content";
import Unauthenticated from "./Unauthenticated";
import { NavigationProvider } from "./context/navigation";
import { getNavigatorLanguage } from "./utils/index";

// style={{
//   width: "100%",
//   zIndex: "10000000000000",
//   height: "auto",
// }}
// id='menu'

export const packagingReportformData = {
  reportType: "",
  startDate: "",
  endDate: "",
};

export const cashInCashOutFormData = {
  startDate: null,
  endDate: null,
  reason: "",
  employee: "",
};

export const distributionReportFormData = {
  sourceLocation: "",
  destinationLocation: [],
  autoCreateAmount: false,
  orderBy: "PRODUCT_NAME",
  orderDirection: "ASC",
  productGroups: [],
  productCategories: [],
  brands: [],
  suppliers: [],
  storeRegion: "",
  reportType: "",
};

export const gstPayableReportFormData = {
  startDate: null,
  endDate: null,
  warehouseIds: [],
  customerIds: [],
  dateRange: "",
};

export const overviewReportData = {
  unixTimeStart: null,
  unixTimeEnd: null,
  currencyId: "",
  pointOfSaleIds: [],
  warehouseIds: [],
  warehouseRegionIds: [],
  varianceReasonCodeIds: [],
  overOrShort: "",
  dateRange: "",
};

export const pnpReportData = {
  unixTimeStart: null,
  unixTimeEnd: null,
  warehouseIds: [],
  dateRange: "",
};

export const taxEmeptReport = {
  userGroupIds: [],
};

const App = () => {
  const { user, loading } = useAuth();

  useEffect(() => {
    locale(getNavigatorLanguage());
  }, []);

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <Unauthenticated />;
};

export default function () {
  const { user, loading } = useAuth();

  return (
    <React.Fragment>
      {user && !user.isIframe ? (
        <>
          {loading ? (
            <div style={{ textAlign: "center", fontSize: "14px" }}>
              loading menu...
            </div>
          ) : (
            <new-user-menu
              clientCode={user ? user.clientCode : ""}
              sessionKey={user ? user.sessionKey : ""}
              accountLang={user ? user.lang : "eng"}
              user={user ? user.user : "User"}
            ></new-user-menu>
          )}
        </>
      ) : null}

      <Router>
        <NavigationProvider>
          <div
            className={`app`}
            style={user && !user.isIframe ? { marginTop: "5%" } : {}}
          >
            <App />
          </div>
        </NavigationProvider>
      </Router>
    </React.Fragment>
  );
}
